import { User, sendEmailVerification, ActionCodeSettings } from "firebase/auth";

function resolveContinueUrlFromHost(hostname: string, protocol: string, port?: string): string {
  if (hostname === "pro.kidsbooked.com") {
    return "https://pro.kidsbooked.com/welcome";
  }
  if (hostname === "staging-admin.kidsbooked.com") {
    return "https://staging-admin.kidsbooked.com/welcome";
  }

  if (hostname === "localhost" || hostname === "127.0.0.1") {
    const portPart = port ? `:${port}` : "";
    return `${protocol}//${hostname}${portPart}/welcome`;
  }

  const trustedHosts = new Set([
    "planbookplay.com",
    "app.kidsbooked.com",
    "staging.kidsbooked.com",
    "kb-prod-fb-proj.web.app",
    "kb-prod-fb-proj.firebaseapp.com",
    "kb-staging-proj.web.app",
    "kb-staging-proj.firebaseapp.com",
  ]);

  if (trustedHosts.has(hostname)) {
    return `https://${hostname}/welcome`;
  }

  return "https://pro.kidsbooked.com/welcome";
}

export function getContinueUrl(): string {
  if (typeof window === "undefined") return "https://pro.kidsbooked.com/welcome";
  const { protocol, hostname, port } = window.location;
  return resolveContinueUrlFromHost(hostname, protocol, port);
}

export async function sendEmailVerificationWithContinueUrl(user: User): Promise<void> {
  if (!user) throw new Error("sendEmailVerificationWithContinueUrl: user is required");
  if (user.emailVerified) return;

  const actionCodeSettings: ActionCodeSettings = {
    url: getContinueUrl(),
    handleCodeInApp: false,
  };

  await sendEmailVerification(user, actionCodeSettings);
}


